import React, { useState, useEffect } from 'react';
import { Container, Card, TextField, Typography, Box, Grid, Autocomplete, FormControl } from '@mui/material';
import StepperSidebar from './StepperSidebar';

const warmColor = '#e67e22';
const warmColorLight = '#fdf2e9';
const warmColorDark = '#d35400';

function SelectBaseImage(props) {
    const [baseImages, setBaseImages] = useState([]);
    const [selected, setSelected] = useState();
    const [textBarContent, setTextBarContent] = useState('');
    const [imageName, setImageName] = useState('');

    const fetchRepoPck = (feedBundle) => {
        fetch(process.env.REACT_APP_URL_REPO +
            '?feedName=' + feedBundle +
            '&packageNameQuery=', {
            credentials: 'include',
            method: "GET"
        })
            .then((resp) => resp.json())
            .then((data) => {
                let resultString = '';
                data.forEach((element) => {
                    resultString += `${element.name}, `;
                });
                resultString = resultString.slice(0, -2);
                setTextBarContent(resultString);
                props.setRepoPkgBundleSelString(resultString);
            })
            .catch((error) => {
                console.log(error, "Errore!");
            });
    }

    useEffect(() => {
        function fetchDefaultData() {
            setTextBarContent('');
            const tempArray = [];
            const payload = {
                datacenter: props.statusForm.datacenter,
                os: props.statusForm.os,
                kindImage: props.statusForm.kindImage
            };

            const formBody = "payload=" + encodeURIComponent(JSON.stringify(payload));

            setTimeout(async () => {
                await fetch(process.env.REACT_APP_URL_BASE_IMAGES, {
                    credentials: 'include',
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: formBody
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        data.forEach((element) => {
                            if (element.imageType === "template") {
                                tempArray.push({
                                    label: `[${element.imageOs}] ${element.imageName} - ${element.imageDes}`,
                                    value: {
                                        idImage: `${element.idImage}`,
                                        imageOs: `${element.imageOs}`,
                                        imageName: `${element.imageName}`,
                                        imageSize: `${element.imageSize}`,
                                        imageSizeCustomizable: `${element.imageSizeCustomizable}`,
                                        feed: `${element.imageFeed}`,
                                        feedBundle: `${element.imageFeedBundle}`,
                                        imageDes: `${element.imageDes}`,
                                        imageType: `${element.imageType}`,
                                        hasAppVolAgent: element.hasAppVolAgent,
                                        destination: {
                                            id: `${element.destId}`,
                                            des: `${element.destDes}`,
                                            url: `${element.destUrl}`,
                                        }
                                    }
                                });
                            }
                        });
                    })
                    .then(() => {
                        setBaseImages(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "Errore!");
                    });
            });
        }

        fetchDefaultData();

        if (props.isBookable) {
            setSelected(null);
        }
    }, [props.isBookable, props.statusForm]);

    function onSelectChange(selectedOption) {
        if (selectedOption) {
            props.setBaseImage(selectedOption.value);
            fetchRepoPck(selectedOption.value.feedBundle);
            setImageName(selectedOption.value.imageName);
            props.setIsBookable(false);
            setSelected(selectedOption);
            props.setMultipleBaseStepCompleted(true);
        }
    }

    const warmInputSx = {
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: warmColor,
                borderWidth: 2,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: warmColorDark,
            },
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: warmColor,
        },
    };

    return (
        <Container maxWidth="lg">
            <Box mb={3}>
                <Typography variant="h6" fontWeight="bold">
                    Seleziona l'Immagine
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Scegli l'immagine base per il tuo laboratorio
                </Typography>
            </Box>

            <Card sx={{ p: 3, borderRadius: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        {/* Autocomplete immagine */}
                        <FormControl fullWidth>
                            <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                sx={{ color: warmColor, mb: 0.5 }}
                            >
                                Immagine da personalizzare
                            </Typography>
                            <Autocomplete
                                value={selected || null}
                                onChange={(event, newValue) => onSelectChange(newValue)}
                                options={baseImages}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Cerca e seleziona un'immagine..."
                                        variant="outlined"
                                        sx={warmInputSx}
                                    />
                                )}
                                freeSolo
                                sx={{
                                    '& .MuiAutocomplete-popupIndicator': { color: warmColor },
                                    '& .MuiAutocomplete-clearIndicator': { color: warmColorDark },
                                }}
                            />
                        </FormControl>
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0 }}
                            value={props.baseImage}
                            required={true}
                            readOnly
                        />

                        {/* Nome immagine */}
                        <Box mt={3}>
                            <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                sx={{ color: warmColor, mb: 0.5 }}
                            >
                                Nome Immagine
                            </Typography>
                            <TextField
                                value={imageName}
                                InputProps={{ readOnly: true }}
                                fullWidth
                                variant="outlined"
                                sx={{
                                    ...warmInputSx,
                                    '& .MuiOutlinedInput-root': {
                                        ...warmInputSx['& .MuiOutlinedInput-root'],
                                        bgcolor: imageName ? warmColorLight : 'transparent',
                                    },
                                }}
                            />
                        </Box>

                        {/* Pacchetti */}
                        <Box mt={3}>
                            <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                sx={{ color: warmColor, mb: 0.5 }}
                            >
                                Pacchetti inclusi
                            </Typography>
                            <TextField
                                value={textBarContent}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        minHeight: '100px',
                                        maxHeight: '100%',
                                        overflow: 'auto'
                                    }
                                }}
                                multiline
                                fullWidth
                                variant="outlined"
                                placeholder="I pacchetti verranno mostrati dopo la selezione dell'immagine"
                                sx={{
                                    ...warmInputSx,
                                    '& .MuiOutlinedInput-root': {
                                        ...warmInputSx['& .MuiOutlinedInput-root'],
                                        bgcolor: textBarContent ? warmColorLight : 'transparent',
                                    },
                                }}
                            />
                        </Box>
                    </Grid>

                    {/* Stepper laterale */}
                    <Grid item xs={12} md={4}>
                        <StepperSidebar
                            currentStep={props.currentStep}
                            statusForm={props.statusForm}
                            selectedImageName={imageName}
                            steps={props.stepsConfig}
                            onBack={props.prevStep}
                        />
                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
}

export default SelectBaseImage;
